const department = {
  DEPARTMENT: 'DEPARTMENT',
  DEPARTMENTS: 'DEPARTMENTS',
};
export { department };
